import { BaseEnum } from "./baseEnum"

const listJobTitleCompetenceLevelTypeEnum: Array<JobTitleCompetenceLevelType> = [];

export class JobTitleCompetenceLevelType extends BaseEnum {
  static NotDefined = new JobTitleCompetenceLevelType(0, 'NotDefined', 'Não Definido');
  static Family = new JobTitleCompetenceLevelType(1, 'Family', 'Família');
  static Position = new JobTitleCompetenceLevelType(2, 'Position', 'Cargo');
  static Function = new JobTitleCompetenceLevelType(3, 'Function', 'Função');

  constructor(public id: number, public value: string, public label: string) {
    super(id, value, label)

    listJobTitleCompetenceLevelTypeEnum.push(this);
  }

  public static getByValue(value: string): JobTitleCompetenceLevelType {
    return this.buildListEnum().find((p: JobTitleCompetenceLevelType) => p.value === value);
  }

  public static enumExists(value: string): boolean {
    return this.buildListEnum().some((p: JobTitleCompetenceLevelType) => p.value === value);
  }

  public static buildListEnum(): Array<JobTitleCompetenceLevelType> {
    return listJobTitleCompetenceLevelTypeEnum;
  }
}